import { Component } from '@angular/core';
import { ConversationUIModule } from '../../../ui/src/conversation-ui.module';

@Component({
  standalone: true,
  imports: [ConversationUIModule],
  template: `
    <inbox-new-message></inbox-new-message>
  `,
  styles: [
    `
      :host {
        width: 100%;
      }
    `,
  ],
})
export class NewMessageComponent {}
